import {
  state,
  getters,
  mutations,
  actions,
} from '@state/modules/localization'


export default {
  state,
  getters,
  actions,
  mutations,
}
